module.exports = __webpack_public_path__ + "img/collect_logo.e9ce0d34.png";